import { useMemo } from "react";
import { useHistory } from "react-router-dom";
import { PATH_ONBOARDING_VERIFICAIONS_BANKING } from "..";
import { useQueryFeatureFlags } from "@hooks/useQueryFeatureFlags";
import { OnboardingFlow } from "../components/OnboardingFlow";
import { OnboardingModule } from "../types";
import { GetMissingFieldsLevelParameter } from "@wingspanhq/wingspan-api-sdk";

export const RouteBankingVerification: React.FC = () => {
  const history = useHistory();
  const queryFeatureFlags = useQueryFeatureFlags();

  const modules = useMemo(
    (): OnboardingModule[] => [
      {
        type: "create_account",
        options: {
          accountTypes: ["Individual", "Business"],
          verificationLevel: GetMissingFieldsLevelParameter.BANKING,
          allowUSInternationalPerson:
            queryFeatureFlags.data?.internationalUsPerson
        },
        title: "Banking verification"
      }
    ],
    [queryFeatureFlags.data?.internationalUsPerson]
  );

  return (
    <OnboardingFlow
      basePath={PATH_ONBOARDING_VERIFICAIONS_BANKING}
      modules={modules}
      onSuccess={() => {
        history.push("/member");
      }}
    />
  );
};
